const AUTH_ENDPOINTS_SKIP_ORGANIZATION_HEADER = [
  '/bff/permission/me/authorized-resources',
];

const getRequestPathname = (url?: string) => {
  if (!url) return '';

  try {
    const base =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost';
    return new URL(url, base).pathname;
  } catch {
    return url;
  }
};

export const shouldSkipOrganizationHeader = (url?: string) => {
  const pathname = getRequestPathname(url);
  return AUTH_ENDPOINTS_SKIP_ORGANIZATION_HEADER.some((endpoint) =>
    pathname.includes(endpoint),
  );
};
